import { targets } from "@github/catalyst";
import { controller } from "./controller";

@controller
export default class DataCheckedElement extends HTMLElement {
  @targets options: HTMLInputElement[] | undefined;
  connectedCallback(): void {
    if (this.options) {
      for (const option of this.options) {
        if (option.getAttribute("data-checked") === "true") {
          option.checked = true;
        }
      }
    }
  }
}

declare global {
  interface Window {
    DataCheckedElement: typeof DataCheckedElement;
  }
  interface HTMLElementTagNameMap {
    "data-checked": DataCheckedElement;
  }
}

if (!window.customElements.get("data-checked")) {
  window.DataCheckedElement = DataCheckedElement;
  window.customElements.define("data-checked", DataCheckedElement);
}
